/*
 * Freight cap: web orders are limited to 250 lb in total (see snippets/freight-cap.liquid).
 *
 * 1. Checkout guard: the cart drawer and cart page hide the checkout button when
 *    cart.total_weight is over the cap, but a cart changed by other scripts
 *    (quick add, apps, another tab) can leave a stale button. Before a checkout
 *    submit, read /cart.js; over the cap, reload the cart page so the freight
 *    notice shows. A failed read lets checkout go ahead (checkout itself returns
 *    no rates for such carts).
 * 2. Product pages: hide the dynamic checkout ("Buy it now" / express) buttons
 *    when quantity x variant weight is over the cap, and clamp the quantity box to
 *    its min/max/step so a typed quantity above the per-line cap cannot reach
 *    checkout through those buttons.
 */
(function () {
  if (window.__freightCap) return;
  window.__freightCap = true;

  var CAP_GRAMS = 113420; // 250 lb + rounding allowance; keep in sync with the Liquid

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  // ---- 1. Checkout guard -------------------------------------------------
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter;
    if (!form || !submitter || submitter.name !== 'checkout') return;
    if (event.defaultPrevented) return;
    event.preventDefault();

    function proceed() {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = submitter.value || '';
      form.appendChild(hidden);
      HTMLFormElement.prototype.submit.call(form);
    }

    fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.total_weight > CAP_GRAMS) {
          window.location.href = cartUrl();
        } else {
          proceed();
        }
      })
      .catch(proceed);
  }, false);

  // ---- 2. Product page express buttons -----------------------------------
  function qtyInputFor(form) {
    if (!form) return null;
    var q = form.elements.namedItem('quantity');
    if (q && !(q instanceof HTMLInputElement)) q = q[0];
    return q || null;
  }

  function clampQty(input) {
    if (!input || input.value === '') return;
    var val = parseInt(input.value, 10);
    if (isNaN(val)) return;
    var min = parseInt(input.min, 10) || 1;
    var max = input.max ? parseInt(input.max, 10) : (input.dataset.max ? parseInt(input.dataset.max, 10) : Infinity);
    var step = parseInt(input.step, 10) || 1;
    var next = val;
    if (next > max) next = max;
    if (next < min) next = min;
    if (step > 1 && next % step !== 0) {
      next = Math.floor(next / step) * step;
      if (next < min) next = min;
    }
    if (next !== val) input.value = next;
  }

  function overCap(wrapper) {
    var form = wrapper.closest('form');
    if (!form) return false;
    var weights = {};
    try { weights = JSON.parse(wrapper.dataset.variantWeights || '{}'); } catch (e) { return false; }
    var idInput = form.querySelector('[name="id"]');
    var grams = Number(weights[String(idInput && idInput.value)] || 0);
    var qtyInput = qtyInputFor(form);
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    return grams * qty > CAP_GRAMS;
  }

  function updateExpress() {
    document.querySelectorAll('[data-freight-cap-express]').forEach(function (wrapper) {
      var over = overCap(wrapper);
      wrapper.hidden = over;
      wrapper.setAttribute('aria-hidden', over ? 'true' : 'false');
      var container = wrapper.closest('product-form') || wrapper.parentElement;
      var notice = container && container.parentElement && container.parentElement.querySelector('[data-freight-cap-product-notice]');
      if (notice) notice.hidden = !over;
    });
  }

  // Block a click on an express button that slipped through (stale state).
  document.addEventListener('click', function (event) {
    var wrapper = event.target.closest && event.target.closest('[data-freight-cap-express]');
    if (!wrapper) return;
    clampQty(qtyInputFor(wrapper.closest('form')));
    updateExpress();
    if (overCap(wrapper)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.name === 'quantity') clampQty(event.target);
    updateExpress();
  });
  document.addEventListener('input', function () { updateExpress(); });

  // Quick-add modals and variant changes can swap product markup in later.
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; updateExpress(); }, 50);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateExpress);
  else updateExpress();
})();
